module.exports = __webpack_public_path__ + "img/noData.f8d41e0a.png";